import { createAction } from 'redux-actions';

export const clearGuestView = createAction('CLEAR_GUEST_VIEW');

export const guestViewAddMember = createAction('GUEST_VIEW_ADD_MEMBER');

export const guestViewUpdateMember = createAction('GUEST_VIEW_UPDATE_MEMBER');
